export default __webpack_public_path__ + "static/media/imone-icon.c7ff79d3.svg";